import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import LoginIllustration from "../../assets/login-illustration.png";
import LoginBackground from "../../assets/login-bg.png";
import * as colors from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { loginStart } from "../../store/auth/reducer";
import {Forgot} from "./forgot";

const DEFAULT_VALUES = {
  email: "",
  password: "",
};

export const Login = ({ setActive, onClose ,setForgot}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { loginLoading, loginError, token } = useSelector(
    (state) => state.auth
  );

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    if (token) {
      reset(DEFAULT_VALUES);
      onClose();
    }
  }, [token]);

  const onSubmit = (values) =>
    dispatch(
      loginStart({
        ...values,
      })
    );
    function forgot(){
      setForgot(true)
      setActive("FORGOT");
    
    }
    function register(){
      setForgot(false)
      setActive("SIGNUP")
      
    }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${LoginBackground})`,
          backgroundRepeat: "no-repeat",
          height: "150px",
        }}
      >
        <img
          src={LoginIllustration}
          alt="Login Illustration"
          width="100px"
          height="100px"
        />
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginTop: "50px",
          }}
        >
          <Typography variant="h4">{t('Login')}</Typography>
          {loginError && <Alert severity="error">{loginError}</Alert>}

          <Controller
            name="email"
            control={control}
            rules={{
              required: {
                value: true,
                message: t('EmailRequired'),
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label={t('EnterYourEmail')}
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.email && errors.email.message}
                error={!!errors.email}
              />
            )}
          />
          <Controller
            name="password"
            control={control}
            rules={{
              required: {
                value: true,
                message: t('PasswordRequired'),
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label={t('EnterPassword')}
                variant="standard"
                type="password"
                sx={{
                  width: "100%",
                }}
                helperText={errors.password && errors.password.message}
                error={!!errors.password}
              />
            )}
          />
          <LoadingButton
            color="primary"
            sx={{
              backgroundColor: "#04B2B2",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#04B2B2",
              },
              marginTop: "10px",
            }}
            loading={loginLoading}
            type="submit"
          >
            {t('Login')}
          </LoadingButton>

          <div onClick={forgot}>
              <Typography
                variant="caption"
                sx={{
                  paddingBlock:"100px",
                  color: colors.blue[600],
                  cursor: "pointer",
                }}
              >
                {t('ForgotPassword')}
              </Typography>
            </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3px",
            }}
          >
            <Typography variant="caption">
              {t('NoAccount')}
            </Typography>
            <div onClick={register}>
              <Typography
                variant="caption"
                sx={{
                  color: colors.blue[600],
                  cursor: "pointer",
                }}
              >
                {t('Register')}
              </Typography>
            </div>

         
          </Box>
        </Box>
      </form>
    </Box>
  );
};
